import { render, staticRenderFns } from "./LanguageSelectorButton.vue?vue&type=template&id=9d5c49c4"
import script from "./LanguageSelectorButton.vue?vue&type=script&lang=js"
export * from "./LanguageSelectorButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports